export default class sitesNavService {
  constructor(gettext) {
    'ngInject';

    this._module = {
      id: 'sites',
      name: gettext('Sites'),
      sref: 'sites',
      priority: 10,
      items: [],
      groups: [],
    };
  }

  getModule() {
    return this._module;
  }
}
